<template>
    <Select
        appearance="menu"
        rounded="md"
        icon-only
        options-width="150px"
        v-bind="$attrs"
        :model-value="valueOption"
        :options="options"
        :background="valueOption.background"
        value-field="id"
        @input="
            $emit('input', $event);
            $emit('update:modelValue', $event);
        "
    >
        <template #option="{ option }">
            <div class="flex p-3">
                <i :class="['mr-3', option.icon, 'h-4 icon w-4', option.text + ' mt-1']"></i>
                <div
                    class="capitalize"
                    v-text="option.name"
                ></div>
            </div>
        </template>
    </Select>
</template>

<script>
import { CARD_ASSESSMENTS, CARD_ASSESSMENT_STYLES } from '@/utils/flashcardUtils';
import { useTranslation } from 'i18next-vue';

export default {
    name: 'SelectAssessment',
    inheritAttrs: false,
    props: {
        modelValue: {
            type: Number,
            default: null,
        },
    },
    emits: ['input', 'update:modelValue'],
    setup() {
        const { t } = useTranslation('flashcards');
        return { t };
    },
    computed: {
        options() {
            return [
                'CORRECT',
                'UNSURE',
                'INCORRECT',
                'HIDDEN',
            ].map((type) => ({
                ...CARD_ASSESSMENTS[type],
                ...CARD_ASSESSMENT_STYLES[type],
                label: this.t(`detailsCardList.assessments.${CARD_ASSESSMENTS[type].name}`),
            }));
        },
        valueOption() {
            return this.options.find((option) => option.id === this.modelValue) || {};
        },
    },
};
</script>

<style lang="scss" scoped>
.selector {
    :deep() {
        .vs__selected-options .icon {
            @apply bg-white w-6 h-6;
        }
        min-width: 4rem !important;

        .vs__dropdown-toggle {
            padding: 0 0.5rem !important;
        }

        .vs__selected {
            opacity: 1 !important;
        }

        .vs__open-indicator {
            filter: brightness(100);
        }
    }
}
</style>
